import { CountUp } from 'countup.js';

export default () => ({ 
    init() {
        
        let target = this.$refs.target;
        let count = Number(target.dataset.count);
        const countUp = new CountUp(target, count, { 
            enableScrollSpy: true,
            scrollSpyDelay: 500,
            scrollSpyOnce: true,
        });
        
        // countUp.handleScroll();
        // countUp.start()

    },
    // start() {
        
    //     if (!this.countUp.error) {
    //         this.countUp.start();
    //     } else {
    //         console.error(this.countUp.error);
    //     }
    // }
})